import type { Editor } from '@tiptap/react';
import type { VariantProps } from 'class-variance-authority';
import type { toggleVariants } from '@/components/ui/toggle';
import { ImageIcon } from '@radix-ui/react-icons';
import { ToolbarButton } from '../toolbar-button';
import ModalAsset from '@/components/sections/builder/settings/modal-asset';
import useModal from '@/hooks/useModal';

interface ImageEditDialogProps extends VariantProps<typeof toggleVariants> {
  editor: Editor;
}

const ImageEditDialog = ({ editor, size, variant }: ImageEditDialogProps) => {
  const selectImageModal = useModal<string>();

  return (
    <>
      <ToolbarButton
        isActive={editor.isActive('image')}
        tooltip='Image'
        aria-label='Image'
        size={size}
        variant={variant}
        type='button'
        onClick={() => selectImageModal.open()}
      >
        <ImageIcon className='size-5' />
      </ToolbarButton>
      <ModalAsset
        openModal={selectImageModal.isShow}
        setOpenModal={(e) => !e && selectImageModal.setIsShow(e)}
        onSelect={(imageUrl) => {
          editor.commands.setImages([{ src: imageUrl }]);
          selectImageModal.close();
        }}
      />
    </>
  );
};

export { ImageEditDialog };
